import type { ScreenDef } from '../app/routes';

export function Placeholder({ screen }: { screen: ScreenDef }) {
  return (
    <section>
      <h1>{screen.title}</h1>
      <p className="muted">이 화면은 {screen.milestone}에서 구현됩니다.</p>
    </section>
  );
}
